<template>
  <el-row>
    <el-col :span="24">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home" />首页
        </el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/demand' }">技术需求库</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="wrap">
        <div class="top">
          <div class="top_img">
            <img :src="pageData.PictureUrl" alt />
          </div>
          <div class="top_text">
            <div class="title">{{ pageData.Title }}</div>
            <div class="address">
              <img src="../../../assets/library/chengguo/公司名称.png" alt />
              所属单位或公司名称：{{ pageData.UnitName }}
            </div>
            <div class="info_box">
              <el-row>
                <el-col :span="10">
                  <p>技术领域：{{ pageData.TechFiel }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.CooperaType">
                    合作方式：{{ pageData.CooperaType }}
                  </p>
                  <p v-else>合作方式：无</p>-->
                  <p>合作方式：{{ pageData.CooperaType }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.ComType">
                    单位性质：{{ pageData.ComType }}
                  </p>
                  <p v-else>单位性质：无</p>-->
                  <p>单位性质：{{ pageData.ComType }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <p v-if="pageData.InvestInFunds">预算金额：{{ pageData.Remark }}万元</p>
                  <p v-else>预算金额：{{ pageData.InvestmentAmount }}万元</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.DemandType">
                    需求类型：{{ pageData.DemandType }}
                  </p>
                  <p v-else>需求类型：无</p>-->
                  <p>需求类型：{{ pageData.DemandType }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.Place">所属地区：{{ pageData.Place }}</p>
                  <p v-else>所属地区：无</p>-->
                  <p>所属地区：{{ pageData.Place }}</p>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <!-- <p v-if="pageData.Release">有效期：{{ pageData.Release }}</p>
                  <p v-else>有效期：</p>-->
                  <p>有效期：{{ pageData.Release }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.StrUpdateTime">
                    更新时间：{{ pageData.StrUpdateTime }}
                  </p>
                  <p v-else>更新时间：无</p>-->
                  <p>更新时间：{{ pageData.StrUpdateTime }}</p>
                </el-col>
                <el-col :span="7">
                  <!-- <p v-if="pageData.DataSource">
                    信息来源：{{ pageData.DataSource }}
                  </p>
                  <p v-else>信息来源：无</p>-->
                  <p>信息来源：{{ pageData.DataSource }}</p>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="top_chart">
            <div class="btn_box">
              <el-button
                class="collection"
                @click="collect"
                v-if="pageData.ClassName == 'n' || pageData.ClassName == ''"
              >
                <img src="../../../assets/library/chengguo/路径 916.png" alt />
                收藏
              </el-button>
              <el-button id="btn2" class="collection" @click="collect" v-else>
                <img src="../../../assets/Home/路径 916.png" alt />
                已收藏
              </el-button>
              <el-button class="docking" @click="wantDocking">
                <img src="../../../assets/library/chengguo/分组 39.png" alt />
                我要对接
              </el-button>
            </div>
            <div class="star">
              形式审查结果：
              <div v-for="i of pageData.Upload" :key="i">
                <img src="../../../assets/library/chengguo/星星.png" alt />
              </div>
              <div v-for="i of 5 - pageData.Upload" :key="i">
                <img src="../../../assets/library/chengguo/星星(1).png" alt />
              </div>
            </div>
          </div>
        </div>
        <div class="center">
          <el-tabs v-model="activeName">
            <el-tab-pane label="需求详情" name="1">
              <div v-if="pageData.DemandContent" class="rich_Text" v-html="pageData.DemandContent"></div>
              <Empty v-else />
            </el-tab-pane>
            <el-tab-pane label="对接动态" name="3">
              <div class="DockingList" v-if="msgList.length > 0">
                <div class="msgContent" v-for="(item, index) in msgList" :key="item.ID">
                  <div class="lis">
                    <div class="LeftInfo">
                      <img src="../../../assets/Home/组 4218.png" alt style="width: 3.625rem" />
                      <div class="Left-R">
                        <p class="pname">{{ formatName(item.RealName) }}</p>
                        <p class="p-border">{{ item.Content }}</p>
                      </div>
                    </div>
                    <div class="RightTime">{{ item.createtime }}</div>
                  </div>
                  <!-- 点赞评论，回复 -->
                  <ul class="commentList">
                    <li v-for="(i, n) in coo[index]">
                      <p>
                        <span class="commentName">{{ i.RealName }} ：</span>
                        <span class="commentText">{{ i.Content }}</span>
                      </p>
                      <p class="commentTime">{{ i.createtime.substring(0, 10) }}</p>
                    </li>
                  </ul>
                  <div class="islike">
                    <p class="comment" @click="comment(item.ID)">
                      <img src="../../../assets/images/组 24783@2x.png" alt />
                      <span>评论</span>
                    </p>
                    <!-- 点赞状态 -->
                    <p v-if="item.Is == 'Y'" @click="liked(item, index)" class="goodjob">
                      <img src="../../../assets/images/组 247866@2x.png" alt />
                      <span>{{ item.r }}</span>
                    </p>
                    <!-- 未点赞状态 -->
                    <p v-else class="goodjob" @click="liked(item, index)">
                      <img src="../../../assets/images/组 24786@2x.png" alt />
                      <span>{{ item.r }}</span>
                    </p>
                  </div>
                  <el-divider></el-divider>
                </div>
              </div>
              <Empty v-else />
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="botm">
          <div class="need">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124_11.png" alt />
              <span>相关成果</span>
            </p>
            <el-divider></el-divider>
            <div class="need_box" v-if="needArr.length > 0">
              <div
                class="need_card_wrap"
                v-for="(item, index) in needArr.slice(0, 6)"
                :key="index"
                @click="goChengguo(item)"
              >
                <div class="need_card">
                  <div class="nc_img">
                    <img :src="item.imgUrl" alt />
                  </div>
                  <div class="nc_text">
                    <div class="title" v-bind:title="item.title">{{ item.title }}</div>
                    <div class="money">
                      合作方式：
                      <span v-bind:title="item.ModeOfCooperation1">{{ item.ModeOfCooperation1 }}</span>
                    </div>
                    <div class="techarea">
                      项目阶段：
                      <span>{{ item.Projectphase1 }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Empty v-else />
          </div>
          <div class="expert">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124.png" alt />
              <span>相关专家</span>
            </p>
            <el-divider></el-divider>
            <div class="expert_box" v-if="aboutPersonCard.length > 0">
              <div class="expert_card" v-for="(v, i) in aboutPersonCard.slice(0, 3)" :key="i">
                <div class="clc-lia" @click="goTalent(v)">
                  <div class="clc-lia-name">
                    <div class="clcime">
                      <img v-if="v.Sex == 0" src="../../../assets/library/蒙版组 125.png" alt />
                      <img v-else src="../../../assets/library/蒙版组 125@2x.png" alt />
                    </div>
                    <div class="fullname">
                      <b>{{ v.FullName }}</b>
                    </div>
                    <div class="TechnicalPosition">{{ v.TechnicalPosition }}</div>
                  </div>
                </div>
                <div class="center_box_text">
                  <div class="text_top" @click="goTalent(v)" v-bind:title="v.University">{{ v.University }}</div>
                  <div class="text_line" @click="goTalent(v)">
                    <span v-bind:title="v.Direction">{{ v.Direction }}</span>
                  </div>
                  <el-button v-if="v.iscollection == 0" @click="follow(v)">+关注</el-button>
                  <el-button v-else @click="follow(v)">已关注</el-button>
                </div>
              </div>
            </div>
            <Empty v-else />
          </div>
          <div class="mechanism">
            <p class="head">
              <img src="../../../assets/library/chengguo/蒙版组 124(1).png" alt />
              <span>相关机构</span>
            </p>
            <el-divider></el-divider>
            <div class="mechanism_box" v-if="OrganArr.length > 0">
              <div
                class="mechanism_card_wrap"
                v-for="(v, i) in OrganArr"
                :key="i"
                @click="goOrgan(v)"
              >
                <div class="mechanism_card">
                  <div class="nc_img">
                    <img :src="v.Url" alt />
                  </div>
                  <div class="nc_text">
                    <div class="title">{{ v.UnitName }}</div>
                    <div class="money">
                      单位性质：
                      <span v-bind:title="v.UnitType">{{ v.UnitType }}</span>
                    </div>
                    <div class="techarea">
                      技术领域：
                      <span>{{ v.TechnicalField }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Empty v-else />
          </div>
        </div>
      </div>
      <Docking
        v-if="dockShow"
        :DialogVisible.sync="dockShow"
        :id="pageData.ID.toString()"
        :ParentId="ParentId"
        :type="'1'"
      />
    </el-col>
  </el-row>
</template>

<script>
import { getAction, postAction } from '@/api/api'
import qs from 'qs'
import {
  library,
  cloudSelect,
  organPool,
  TypeList,
  colect,
  Docking1,
} from '@/api/url'
import Docking from '@/components/Docking.vue'
// import Docking from "../../../components/Docking";
import Empty from '../../../components/empty.vue'
import { Adaptation1} from '@/api/Adaptation'
export default {
  name: '',
  data() {
    return {
      msgList: [],
      ParentId: 0,
      shatwon: [],
      coo: [],
      activeName: '1',
      aboutPersonCard: [], // 相关专家
      pageData: {},
      needArr: [], // 需求数组
      OrganArr: [], // 专家数组
      dockShow: false,
      dockArr: [],
      id:''
    }
  },
  props: {},
  components: { Docking, Empty },
  created() {
    this.id=this.$route.query.id
    this.$bus.$emit('ChangeFocus', 2)
  },
  mounted() {
    Adaptation1(this,this.id, this.id,'/demandDetail','NeedPoolDetail?id=')
    this.getPageData()
    // this.getAboutNeed();
    this.getMessage()
    // this.getDockD();
    this.getAboutPerson()
    this.getAboutOrganPool()
    this.$bus.$on('LoginSuccess', (e) => {
      //// console.log(e);
      if (e) {
        this.getPageData()
        this.getAboutPerson()
        this.getAboutOrganPool()
      }
    })
  },
  methods: {
    // getDockD() {
    //   let data = {
    //     action: "Get_TechFieldList",
    //     sort: "DESC",
    //     projId: this.$route.query.id,
    //   };
    //   postAction(TypeList, qs.stringify(data)).then((res) => {
    //     //// console.log(res);
    //     this.dockArr = res;
    //   });
    // },
    //获取对接列表
    getMessage() {
      let data = {
        action: 'UserLeaveList',
        UserID: localStorage.getItem('userId'),
        // UserID:1,
        projectid: this.$route.query.id,
        // projectid: 74497,
        type: '1',
        pageIndex: '1',
        pageSize: '10',
        // ParentId:'0',
        ParentId: 0,
      }
      getAction(Docking1, data).then((res) => {
        //// console.log(res);
        this.msgList = res.list
        if (res.list.length == 0) {
          this.showEmpty = true
        } else {
          this.showEmpty = false
        }
        res.list.forEach((item, index) => {
          if (item.r == null) {
            item.r = 0
          }length
          let b = {
            action: 'UserLeaveList',
            pageIndex: 1,
            pageSize: '',
            projectid: this.$route.query.id,
            // projectid: 74497,
            type: '1',
          }
          b.ParentId = item.ID

          ////// console.log(b);
          getAction(Docking1, b).then((res) => {
            //// console.log("评论内容", res);
            this.shatwon = res.list

            if (this.coo.length == index) {
              this.coo.push(this.shatwon)
            }
          })
        })
      })
    },

    // 点赞
    liked(a, index) {
      let RealName = localStorage.getItem('RealName')
      //// console.log("RealName", RealName);

      if (RealName == '' || RealName == null) {
        let vm = this
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        //// console.log(a);
        // this.islikeflag = !this.islikeflag;
        // //// console.log(this.islikeflag)
        let data = {
          action: 'Support',
          userid: localStorage.getItem('userId'),
          // userid:1,
          projectid: a.ID,
        }
        postAction(Docking1, this.$qs.stringify(data)).then((res) => {
          //// console.log(res);
          let data = {
            action: 'UserLeaveList',
            UserID: localStorage.getItem('userId'),
            // UserID:1,
            projectid: this.$route.query.id,
            // projectid: 74497,
            type: '1',
            pageIndex: '1',
            pageSize: '',
            // ParentId:'0',
            ParentId: 0,
          }
          getAction(Docking1, data).then((res) => {
            //// console.log(res);
            //// console.log(index);
            if (this.msgList[index].Is == 'Y') {
              this.msgList[index].r -= 1
            } else {
              this.msgList[index].r += 1
            }

            this.msgList[index].Is = res.list[index].Is
          })
        })
      }
    },
    //评论
    comment(a) {
      //// console.log(a); //列表的ID
      this.ParentId = Number(a)

      let RealName = localStorage.getItem('RealName')
      let vm = this

      // 判断是否登录
      if (RealName == '') {
        vm.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        // 打开弹框
        this.dockShow = true
        // //// console.log("需求详情我要对接的ProjectID", this.ProjectID);
        // //// console.log("点击了yunDetail我要对接")
        // //// console.log('this.DialogVisible',this.dDialogVisible)
      }
    },
    // 我要对接
    wantDocking() {
      let RealName = localStorage.getItem('RealName')
      if (RealName == '') {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      } else {
        this.dockShow = true
        //// console.log(this.dockShow);
      }
    },
    goChengguo(a) {
      // 跳转成果详情
      //// console.log(a);
      const { href } = this.$router.resolve({
        path: '/fruitDetail',
        query: {
          id: a.id,
        },
      })
      window.open(href, '_blank')
    },
    // 收藏项目
    collect() {
      let RealName = localStorage.getItem('RealName')
      if (!RealName == '') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID') || 0,
          ProjectID: this.$route.query.id,
          Type: 2,
        }
        postAction(colect, qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success(res.info)
            this.getPageData()
          } else {
            this.$message.success(res.info)
            this.getPageData()
          }
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    // 关注专家
    follow(a) {
      //// console.log(a);
      let RealName = localStorage.getItem('RealName')
      if (!RealName == '') {
        let data = {
          action: 'Collection_Items',
          UserID: localStorage.getItem('RealID'),
          ProjectID: a.id,
          Type: 3,
        }
        postAction(library, qs.stringify(data)).then((res) => {
          //// console.log(res);
          if (res.status == 'y') {
            this.$message.success('关注成功！')
            this.getAboutPerson()
          } else {
            this.$message.success('取消关注')
            this.getAboutPerson()
          }
        })
      } else {
        this.$confirm('当前未登录, 是否登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.$bus.$emit('dialogVisible', 'true')
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      }
    },
    // //登陆成功
    // LoginSuccess() {
    //   let data = {
    //     action: "Get_UserInfo",
    //   };
    //   postAction(library, this.$qs.stringify(data)).then((res) => {
    //     this.RealName = res.RealName;
    //     localStorage.setItem("RealName", res.RealName);
    //     localStorage.setItem("RealID", res.ID);
    //   });
    // },
    // 获取信息
    getPageData() {
      let data = {
        action: 'Get_DemandInfo',
        id: this.$route.query.id,
      }
      postAction(library, qs.stringify(data)).then((res) => {
        //// console.log(res);
        if (res) {
          if (res.UpdateTime) {
            res.UpdateTime = this.getdata(res.UpdateTime)
          }
          if (res.Upload == 'A') {
            res.Upload = 5
          } else if (res.Upload == 'B') {
            res.Upload = 4
          } else if (res.Upload == 'C') {
            res.Upload = 3
          } else if (res.Upload == 'D') {
            res.Upload = 2
          } else if (res.Upload == 'E') {
            res.Upload = 1
          }
          this.pageData = res
          this.getAboutNeed(res.ID)
        }
      })
    },
    // 格式化时间
    getdata(val) {
      var timestamp = val
      var date = new Date(
        parseInt(timestamp.replace('/Date(', '').replace(')/', ''), 10)
      )
      //// console.log(date);
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m
    },
    // 获取相关需求
    getAboutNeed() {
      let data = {
        action: 'Get_MatchingData',
        // id: this.$route.query.id,
        id: this.pageData.ID,
        type: 2,
      }
      //// console.log(data, "111111111111111111111");
      getAction(TypeList, data).then((res) => {
        //// console.log(res);
        // this.needArr = res.list;
        this.getNeed(JSON.stringify(res))
      })
    },
    getNeed(a) {
      let data = {
        action: 'Replay_AchievementInfo',
        formMap: a,
      }
      //// console.log(data, "111111111111111111111");
      postAction(TypeList, qs.stringify(data)).then((res) => {
        //// console.log(res);
        this.needArr = res
      })
    },
    // 获取相关专家
    getAboutPerson() {
      let data = {
        action: 'GetCorrelationSpecialistList',
        id: this.$route.query.id,
        type: 0,
      }
      getAction(cloudSelect, data).then((res) => {
        //// console.log(res);
        // res.list.map((item) => {
        //   item.Direction = item.Direction.split('|')
        // })
        this.aboutPersonCard = res.list
      })
    },
    // 获取相关机构
    getAboutOrganPool() {
      let data = {
        action: 'Random_List',
        row: 6,
      }
      postAction(organPool, qs.stringify(data)).then((res) => {
        //// console.log(res);
        this.OrganArr = res
      })
    },
    goTalent(a) {
      const { href } = this.$router.resolve({
        path: '/talentPoolinfo',
        query: {
          list: a.id,
        },
      })
      window.open(href, '_blank')
    },
    goOrgan(a) {
      const { href } = this.$router.resolve({
        path: '/OrganizationDetail',
        query: {
          id: a.ID,
          type: a.Type,
        },
      })
      window.open(href, '_blank')
    },
     formatName(name) {
      let newStr
      if (name.length === 2) {
        newStr = name.substr(0, 1) + '*'
      } else if (name.length > 2) {
        if (
          name.indexOf('学院') != -1 ||
          name.indexOf('大学') != -1 ||
          name.indexOf('研究院') != -1 ||
          name.indexOf('中心') != -1 ||
          name.indexOf('联盟') != -1
        ) {
          newStr = name
        } else {
          let char = ''
          for (let i = 0, len = name.length - 2; i < len; i++) {
            char += '*'
          }
          newStr = name.substr(0, 1) + char + name.substr(-1, 1)
        }
      } else {
        newStr = name
      }

      return newStr
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .el-breadcrumb {
  width: 86.25rem;
  margin: 0 auto;
  padding: 1.25rem;
}
.wrap {
  width: 87.5rem;
  box-shadow: 0rem 0rem 0.9375rem rgba(0, 0, 0, 0.06);
  opacity: 1;
  border-radius: 0rem;
  margin: 0 auto;
  padding: 2.1875rem 1.875rem;
}
.top {
  display: flex;
  justify-content: space-between;
  .top_img {
    width: 26.25rem;
    height: 14.125rem;
    overflow: hidden;
    img {
      width: 100%;
      // height: 100%;
      vertical-align: bottom;
    }
  }
  .top_text {
    width: 42.8125rem;
    margin-left: 2.5rem;
    text-align: left;
    .title {
      font-size: 1.625rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
      margin-bottom: 0.875rem;
    }
    .address {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;
      margin-bottom: 1rem;
    }
    .info_box {
      p {
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        opacity: 1;
        margin-top: 0.875rem;
      }
    }
  }
  .top_chart {
    .btn_box {
      display: flex;
      justify-content: flex-end;
      .collection {
        width: 8.9rem;
        height: 3rem;
        background: #ff9e57;
        opacity: 1;
        border-radius: 0.3125rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        margin-left: 10px;
        img {
          width: 1rem;
          height: 0.875rem;
          vertical-align: bottom;
          margin-right: 0.625rem;
        }
      }
      .docking {
        width: 8.9rem;
        height: 3rem;
        background: #2769dc;
        opacity: 1;
        border-radius: 0.3125rem;
        font-size: 0.875rem;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        opacity: 1;
        img {
          width: 1rem;
          height: 0.875rem;
          vertical-align: bottom;
        }
      }
      /deep/ .el-button {
        padding: 0;
      }
    }
    .star {
      display: flex;
      margin-top: 0.9375rem;
      div {
        margin: 0 0.0625rem;
        img {
          width: 1.5625rem;
          height: 1.5625rem;
          vertical-align: bottom;
        }
      }
    }
  }
}
.center {
  margin-top: 2.3125rem;
  /deep/.el-tabs__nav {
    width: 100%;
    text-align: left;
    .el-tabs__item {
      font-size: 1.75rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      margin-bottom: 0.625rem;
      color: #999999;
      opacity: 1;
    }
    .el-tabs__active-bar {
      width: 6.9375rem !important;
      height: 0.1875rem;
      background-color: #0561d2 !important;
    }
    .is-active {
      color: #0561d2 !important;
      opacity: 1;
    }
    .el-tabs__item {
    }
  }
  .rich_Text {
    text-align: left;
  }
}
/deep/ .el-tabs__item:focus.is-active.is-focus:not(:active) {
  box-shadow: 0 0;
  border-radius: 0;
}
.botm {
  margin-top: 2.3125rem;
  .need {
    margin-bottom: 2.3125rem;
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .need_box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }
    .need_card_wrap {
      width: 26.9375rem;
      height: 22.9375rem;
      display: flex;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      margin-bottom: 1.5rem;
      .need_card {
        cursor: pointer;
        .nc_img {
          width: 26.9375rem;
          height: 14.5625rem;
          img {
            width: 100%;
            height: 100%;
            vertical-align: bottom;
          }
        }
        .nc_text {
          // width: 23.9375rem;
          padding: 1.5rem;
          text-align: left;
          .title {
            width: 23.9375rem;
            font-size: 1.1875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4a4a4a;
            opacity: 1;
            margin-bottom: 0.75rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .money {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d0d0d0;
            opacity: 1;
            margin-bottom: 0.5rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 90%;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #f15916;
              opacity: 1;
            }
          }
          .techarea {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c9c9c9;
            opacity: 1;
            span {
              width: 100%;
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
  .expert {
    margin-bottom: 2.3125rem;
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .expert_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .expert_card {
      width: 26.9375rem;
      height: 22.9375rem;
      margin-bottom: 0.625rem;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      .clc-lia {
        cursor: pointer;
      }
      .clc-lia-name {
        padding: 2.5rem 1.5rem;
        background: #f7f7f7;
        margin-top: 4.25rem;
        text-align: left;
        box-sizing: border-box;
        position: relative;
        width: 22rem;
        .clcime {
          position: absolute;
          bottom: -0.5625rem;
          right: -2.5625rem;
          width: 8.75rem;
          height: 8.75rem;
          background: #fff;
          border-radius: 50%;
          img {
            width: 8.0625rem;
            height: 8.0625rem;
            z-index: 10;
            margin: 0.25rem 0.25rem 0;
          }
        }

        .fullname {
          b {
            font-size: 1.25rem;
          }
        }
        .TechnicalPosition {
          color: #999;
        }
      }
      .clc-lia-name::before {
        content: '';
        display: block;
        width: 0.1875rem;
        height: 50%;
        position: absolute;
        top: 50%;
        left: 0rem;
        transform: translateY(-50%);
        background: #0561d2;
      }
      .center_box_text {
        margin-top: 2.0625rem;
        /deep/ .el-button {
          padding: 0;
        }
        .text_top {
          margin-bottom: 0.75rem;
          font-size: 1rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          opacity: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        }
        .text_line {
          width: 50%;
          margin: 0 auto;
          margin-bottom: 0.625rem;
          font-size: 0.875rem;
          font-family: Source Han Sans CN;
          font-weight: 400;
          line-height: 1.875rem;
          color: #999999;
          opacity: 1;
          display: flex;
          span {
            width: 45%;
            padding: 0 0.1875rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
            text-align: right;
          }
        }
        /deep/ .el-button {
          width: 6.3125rem;
          height: 2.1875rem;
          background: #2769dc;
          opacity: 1;
          border-radius: 0.25rem;
          i {
            color: #fff;
          }
          span {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            opacity: 1;
          }
        }
      }
    }
  }
  .mechanism {
    .head {
      text-align: left;
      img {
        width: 2rem;
        height: 2rem;
        vertical-align: top;
      }
      span {
        margin-left: 0.25rem;
        font-size: 1.75rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        line-height: 2rem;
        color: #333333;
        opacity: 1;
      }
    }
    .mechanism_box {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    .mechanism_card_wrap {
      margin-bottom: 1.5rem;
      width: 26.9375rem;
      height: 22.9375rem;
      display: flex;
      background: #ffffff;
      box-shadow: 0rem 0.1875rem 1.25rem rgba(0, 0, 0, 0.1);
      opacity: 1;
      border-radius: 0rem;
      .mechanism_card {
        width: 100%;
        cursor: pointer;
        .nc_img {
          width: 100%;
          height: 14.5625rem;
          img {
            width: 100%;
            vertical-align: bottom;
          }
        }
        .nc_text {
          padding: 1.5rem;
          text-align: left;
          .title {
            width: 23.9375rem;
            font-size: 1.1875rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #4a4a4a;
            opacity: 1;
            margin-bottom: 1rem;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            word-break: break-all;
          }
          .money {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #d0d0d0;
            opacity: 1;
            margin-bottom: 0.5rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
             
            }
          }
          .techarea {
            width: 100%;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #c9c9c9;
            opacity: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            span {
              font-size: 0.875rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 1.625rem;
              color: #8b8b8b;
              opacity: 1;
            }
          }
        }
      }
    }
  }
}
.dockD_wrap {
  padding: 1.5rem 2.5625rem;
}
.dockD {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.625rem;
  .dock_img {
    width: 3.625rem;
    height: 3.625rem;
    img {
      width: 100%;
      vertical-align: top;
    }
  }
  .dock_text {
    width: 80%;
    text-align: left;
    h3 {
      font-size: 1.125rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;
      opacity: 1;
    }
    p {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      opacity: 1;
    }
  }
  .tiem {
    span {
      font-size: 1rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      opacity: 1;
    }
  }
}
#btn2 {
  border: 0.0625rem solid #ff9e57;
  background: #ffffff;
  color: #ff9e57;
}
.DockingList {
  margin-top: 2.375rem;
  /* margin-left: 2.125rem; */
  /* margin-right: 2.375rem; */
  font-size: 1rem;
  /* 分割线 */
  /deep/.el-divider--horizontal {
    margin-top: 0;
    margin-left: 4.1875rem;
    width: 92%;
    margin-bottom: 1.3125rem;
  }
  .lis {
    display: flex;
    /* height: 5.0625rem; */
    justify-content: space-between;
    .RightTime {
      margin-top: 0.5625rem;
      color: #999999;
    }
  }

  .LeftInfo {
    display: flex;
    color: #666666;
    img {
      width: 3.625rem;
      height: 3.625rem;
      vertical-align: middle;
      margin-right: 1rem;
    }
    .Left-R {
      text-align: left;
      .pname {
        font-size: 1.125rem;
        font-family: Microsoft YaHei;
        font-weight: bold;
        /* line-height: 24px; */
        color: #333333;
      }
      .p-border {
        width: 70.3125rem;
        margin-top: 0.5rem;
        padding-bottom: 1.5625rem;
        font-size: 1rem;
        font-family: Microsoft YaHei;
        font-weight: 80%;
        /* line-height: 21px; */
        color: #666666;
      }
    }
  }
}
.commentName {
  color: #2a3457;
  font-size: 1rem;
  font-family: Microsoft YaHei;
}
.commentTime {
  margin-top: 0.5rem;
}
.commentText {
  color: #9fa3b3;
}
.commentList {
  width: 77.625rem;
  margin: 0 auto;
  text-align: left;
  li {
    background: rgba(249, 249, 249, 0.39);
    margin-bottom: 1.25rem;
  }
}
.islike {
  display: flex;
  margin-left: 4.55rem;
  margin-bottom: 1.25rem;
  .goodjob {
    img {
      width: 14px;
      margin-right: 5px;
      vertical-align: middle;
    }
  }
  .comment {
    margin-right: 21px;
    img {
      vertical-align: middle;
      width: 14px;
      margin-right: 5px;
    }
  }
}
</style>